export const FirebaseConfig = {
	"projectId": "sawiride",
	"appId": "1:428807829639:web:bceb9347d60d5617dd6022",
	"databaseURL": "https://sawiride-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "sawiride.appspot.com",
	"locationId": "europe-west",
	"apiKey": "AIzaSyDYENGEgnyvxEZa7y6LFyl-PpzZbDub-pA",
	"authDomain": "sawiride.firebaseapp.com",
	"messagingSenderId": "428807829639",
	"measurementId": "G-3W2B5LW95S",
	"projectNumber": "428807829639",
	"version": "2"
};